export enum TrackerEvents {
  VIEW_PAGE = 'Ver Pagina',
  SEARCH = 'Buscar',

  // Expedients =================
  CREATE_EXPEDIENT = 'Crear Expediente',
  ADD_EXPEDIENT_INTERVENER = 'Añadir Interviniente',
  EDIT_EXPEDIENT = 'Editar Expediente',
  PRINT_EXPEDIENTS = 'Imprimir Expedientes',

  // Actions =================
  CREATE_ACTION = 'Crear actuacion',
  REMOVE_ACTION = 'Eliminar actuacion',
  EDIT_ACTION = 'Editar actuacion',

  // Economic Data =================
  CREATE_ECONOMIC_DATA = 'Nuevo dato economico',
  REMOVE_ECONOMIC_DATA = 'Eliminar dato economico',
  IMPORT_ACTIONS_IN_ECONOMIC_DATA = 'Importar actuaciones a datos economicos',
  INVOICE_ECONOMIC_DATA = 'Facturar datos economicos',

  // INVOICE =====================
  CREATE_INVOICE = 'Crear factura',
  EDIT_INVOICE = 'Editar factura',

  // Contact =================
  CREATE_CONTACT = 'Crear contacto',
  EDIT_CONTACT = 'Editar contacto',

  // Documentos =================
  NEW_DOCUMENT_TEMPLATE = 'Nuevo documento plantilla',

  // ===============
  OPEN_LEFEBVRE_MAIL = 'Abrir en Lefebvre Mail',
  CREATE_MAIL_ACTION = 'Crear actuación correo',
  ATTACH_TO_MAIL = 'Adjuntar a correo',

  TAB_VIEW = 'Pestaña abierta',

  OPEN_EXPEDIENT = 'Open Expedient',
  REMOVE_EXPEDIENT = 'Eliminar Expediente',
  DUPLICATE_EXPEDIENT = 'Duplicar Expediente',

  ACTIONS_BUTTONS = 'Actions Buttons',
  GRID_TABLE_TOOLBAR = 'Grid Table Toolbar',
  GRID_TABLE_CONTEXT_MENU = 'Grid Table Context Menu',
  SIMPLE_GRID_TOOLBAR = 'Simple Grid Toolbar',
  GRID_LOADED = 'Grid cargado',
  ERROR_GLOBAL = 'ERROR GLOBAL:',
  ERROR = 'ERROR:',

  DOCS_IA = 'Documentos analizados',
  // NAVIGATION DRAWER
  OPEN_NAVIGATION_DRAWER = 'Ampliar menú',
  CLOSE_NAVIGATION_DRAWER = 'Minimizar menú',

  // SEARCH IA
  CLICK_AI_SEARCH = 'Click consulta IA',
  IA_FILTER_APPLIED = 'Filtro consulta IA',
  AI_SEARCH = 'Consulta IA',
  CLICK_PROMPT_SUGGESTION = 'Sugerencia prompt IA',
  LOADING_RESULTS_AI_SEARCH = 'Carga de respuesta consulta IA',
  AI_SEARCH_RESULTS_VIEWED = 'Resultado consulta IA',
  AI_SEARCH_DOCUMENT_OPENED = 'Abrir documento desde consulta IA',
  AI_SEARCH_REFERENCE_OPENED = 'Abrir referencia desde consulta IA',
  AI_SEARCH_ACTION_CLICKED = 'Botones de acción la respuesta en consulta IA',
  AI_SEARCH_FEEDBACK_SUBMITTED = 'Feedback consulta IA',
  AI_SEARCH_NEW = 'Nueva consulta IA',

  // LANDBOT
  CLICK_LANDBOT_BUBBLE = 'Burbuja chat ayuda',
  LAUNCH_LANDBOT = 'Click Iniciar Chat',
  OPEN_SUPPORT_SERVICE_DIALOG = 'Icono ayuda',

  // KEBAB_MENU
  KEBAB_OPENED = 'Abrir menú kebab',
  KEBAB_OPTION_SELECTED = 'Click menú kebab',

  // DIALOG
  DIALOG_OPENED = 'Diálogo abierto',

  // INTERNAL MESSAGE
  SEND_INTERNAL_MESSAGE = 'Enviar mensaje interno',
  OPEN_SEND_INTERNAL_MESSAGE = 'Abrir diálogo enviar mensaje interno',
  VIEW_DETAIL_INTERNAL_MESSAGE = 'Ver detalle mensaje interno'
}

export interface Tracker {
  init: (token: string, config?: object) => void
  trackEvent: (event: string, properties?: object) => void
  // trackError: (event: string, message: string | unknown, information?: string | object | unknown) => void
  register: () => void
  reset: () => void
  pageView: () => void
  checkMixPanel: () => boolean
}
